import { BdcCreditNoteSummary } from "../../../types/bdc.type";
import Tag from "../Tag";
import { CN_STATUS } from "./cn";

/** ร่าง / ออกแล้ว / ส่ง 7-11 แล้ว / ยกเลิก, plus ทดสอบ (TC…) and วางบิลแล้ว. */
export default function CreditNoteStatusChip({
  note,
}: Readonly<{ note: Pick<BdcCreditNoteSummary, "status" | "is_test" | "billing_uuid"> }>) {
  const status = CN_STATUS[note.status] ?? { label: note.status, tone: "mut" as const };
  return (
    <>
      <Tag tone={status.tone}>{status.label}</Tag>
      {note.is_test && (
        <>
          {" "}
          <Tag tone="warn">ทดสอบ</Tag>
        </>
      )}
      {note.billing_uuid && note.status !== "cancelled" && (
        <>
          {" "}
          <Tag tone="info">วางบิลแล้ว</Tag>
        </>
      )}
    </>
  );
}
